import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api/search';

const apiSearchTimeReports = async (req)=> new Promise((resolve, reject)=> axiosConsumer().post(`${resource}/`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const SearchRepository = {
  search: apiSearchTimeReports
};